import { For } from 'solid-js';
import { SITE } from '../../config/site';
import { PixelIcon } from '../PixelIcon';

export function AboutWindow() {
  return (
    <div class="window-body app-window-body about-window">
      <div class="about-hero">
        <div class="about-avatar" aria-hidden="true">IS</div>
        <div>
          <h1>Ivan Sivák</h1>
          <p>AI Founder &amp; Researcher · Founder of BotX, acquired by Synthreo</p>
          <small>{SITE.location}</small>
        </div>
      </div>

      <fieldset>
        <legend>About</legend>
        <For each={SITE.about}>{(paragraph) => <p>{paragraph}</p>}</For>
      </fieldset>

      <div class="about-links">
        <a class="button-link" href="https://github.com/ivansivak86" target="_blank" rel="noreferrer">
          <PixelIcon name="github" size={18} /> View GitHub
        </a>
      </div>

      <p class="dialog-note">For the conventional chronology, employment history, and professional details, LinkedIn remains the appropriate place. This website is primarily about the work itself.</p>
    </div>
  );
}
